<div class="user-landing-continer m-0 p-5 pt-0  primary-bg">

    <div class="header-wrapper primary-bg">
        <div class="header-col-1">
            <div class="custom-search">
                <img src="assets/settings/search-small.svg">
                <input class="border-dark-bottom" type="search" id="input" placeholder="Type to search here" [(ngModel)]="searchUserList"
                    (click)="$event.stopPropagation()">
            </div>
        </div> 

        <div class="header-col-2">
            <div class="add-user-btn submit" (click)="addNewUser()">
                <img class="icon-m" src="assets/settings/plus.svg" alt="">
                <p class="white-text">Add New User</p>
            </div>
        </div>
    </div>
    <div class="body-wrapper pt-0 px-5 pb-5 radius-s white-bg">
        <div class="body-top py-4">
            <div class="body-top-col-1">
                <img src="assets/settings/left-arrow.svg" [ngClass]="settingsVarService.pages.presentPage | disableAction:settingsVarService.pages.length:-1"
                    (click)="pagination_click('left')">
                <p class="content-m">{{settingsVarService.pages.presentPage}} of {{settingsVarService.pages.length >0 ?
                    settingsVarService.pages.length:'1'}} </p>
                <img src="assets/settings/right-arrow.svg" [ngClass]="settingsVarService.pages.presentPage | disableAction:settingsVarService.pages.length:1"
                    (click)="pagination_click('right')">
            </div>

            <div class="body-top-col-2">
                <ng-container *ngFor="let pagedat of settingsVarService.commonData.pagination | keyvalue">
                    <p class="content-m black-text lighter-text">{{pagedat.key}}</p>
                    <app-overlay-select [formControl]="settingsVarService.userPagination" [data]="pagedat.value"
                        [style]="{'font-size':'12px'}">
                    </app-overlay-select>
                </ng-container>

            </div>
        </div>
        <div class="body-bottom">
            <ng-container *ngIf="!mat_spinner_userList_state">
                <ng-container *ngIf="!settingsVarService.errorhandleuserlanding.status">
                    <table>
                        <thead>
                            <tr>
                                <th *ngFor="let header of settingsVarService.userTableHeader.headers">{{header}}</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let users of settingsVarService.userList |searchFilter: searchUserList"
                                (click)="editUser(users.user_id,$event)">
                                <td class="without_approval pt-0 pl-3 pr-0 pb-0"> 
                                    <img class="icon-m" *ngIf="users.status == 1" src="assets/settings/greenTick.svg">
                                    <img class="icon-m" *ngIf="users.status == 0" src="assets/settings/greyTick.svg">
                                    <img class="icon-m" *ngIf="users.status == 2" src="assets/settings/warning.svg">
                                </td>
                                <td class="without_approval" [tooltip]="users.user_id"> {{users.user_id}} </td>
                                <td class="without_approval" [tooltip]="users.user_id+' '+users.lname"> {{users.fname}} {{users.lname}}</td>
                                <td class="without_approval" [tooltip]="users.role_assingned"> {{users.role_assingned}} </td>
                                <td class="without_approval" [tooltip]="users.mobile"> {{users.mobile}} </td>
                                <td class="without_approval" [tooltip]="users.email"> {{users.email}} </td>
                                <td class="change_approval"> 
                                    <span *ngIf="users.new_mobile" [tooltip]="users.new_mobile"> {{users.new_mobile}} </span>
                                    <span  [tooltip]="users.new_email" *ngIf="(users.new_mobile) && (users.new_email && users.new_email != 'null')">
                                        ,
                                        {{users.new_email}} </span>
                                    <span [tooltip]="users.new_email"
                                        *ngIf="(!users.new_mobile ) && (users.new_email && users.new_email != 'null')">
                                        {{users.new_email}}
                                    </span>
                                </td>
                                <td class="user-icon-button pt-0 pl-3 pr-0 pb-0">
                                    <img class="show-btn tooltip-enable"  (click)="editUser(users.user_id,$event) "
                                        src="assets/settings/edit-row.svg" tooltip="Edit User">
                                    <img *ngIf="users.user_id != userName "  class="show-btn tooltip-enable"
                                        (click)="deleteUser(users.user_id,$event)" src="assets/settings/delete.svg" tooltip="Delete User">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </ng-container>
                <ng-container class="nodata-container" *ngIf="settingsVarService.errorhandleuserlanding.status">
                    <div class="userlist-nodata pt-1" >
                        <div class="nodata-img">
                            <img src="assets/designer/empty-data.svg">
                        </div>
                        <div>
                            <p class="m-0 content-l bold-text">{{settingsVarService.errorhandleuserlanding.errmsg}}</p>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="mat_spinner_userList_state">
                <div class="body-bottom-spinner">
                    <mat-spinner class="spinner mx-6 my-auto" diameter=20></mat-spinner>
                </div>
            </ng-container>
            <ng-container *ngIf="mat_spinner_userList_editState">
                <div class="body-bottom-spinner_edit">
                    <mat-spinner class="spinner mx-8 my-auto" diameter=20></mat-spinner>
                </div>
            </ng-container>
        </div>
    </div>
</div>